import { useSelector } from 'react-redux';
import type { RadioFilterOption } from '../../generic/Filter';
import { FilterPanel } from '../../generic/Filter';
import * as IssuesV2Store from '../../../redux/issuesV2';
import type { FoundAfterOption } from '../../../redux/issuesV2/foundAfterFilter';
import useFetchIssuesAction from '../IssuesInbox/hooks/useFetchIssuesAction';
import FilterCardRadios from '../../generic/Filter/FilterCardRadios';

const foundAfterLabels: Record<FoundAfterOption, string> = {
  anytime: 'Anytime',
  last7days: 'Last 7 days',
  last14days: 'Last 14 days',
  last30days: 'Last 30 days',
};

const filterOptions: RadioFilterOption[] =
  Object.entries(foundAfterLabels).map(([value, label]) => ({ value, label }));

/**
 * A filter panel that lets the user select only items found in the last N days.
 * Options are determined by the valid `foundAfter` values.
 */
const FoundAfterFilter = () => {
  const setFoundAfter = useFetchIssuesAction(IssuesV2Store.actions.setFoundAfter);

  const filter = useSelector(IssuesV2Store.selectors.getFilter);

  return (
    <FilterPanel>
      <FilterCardRadios
        label="First Found"
        options={filterOptions}
        value={filter?.foundAfter ?? 'anytime'}
        onChange={setFoundAfter}
      />
    </FilterPanel>
  );
};

export default FoundAfterFilter;
